// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"126":"ab23254d","440":"14dfd3d8","581":"9eb0e7e7"}[chunkId] + ".chunk.js";
};